export const ProductTypes =  {
    full: 1,
    serviceDriveOnly: 2,
    fca_Express: 3,
    fca_Full: 4,
    euroLite: 5
};
